export default "__VITE_ASSET__ec34e9d1__"